import React from "react";
import options from "../config/districtOfficeOptions";

let orgSelect = function (onChange, queryParams, labelwidth) {
  let lw = labelwidth === undefined ? "inherit" : labelwidth.toString() + "px";
  let org = queryParams.org === undefined ? "" : queryParams.org;

  return (
    <div title="Choose a USACE Division or District" className="tableItem">
      <div className="tableItem" style={{ width: lw }}>
        Filter by District:
      </div>
      <div className="tableItem">
        <select
          id="org"
          value={org}
          className="selectlist"
          size="1"
          onChange={onChange}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

let yearSelect = function (onChange, queryParams, labelwidth) {
  let lw = labelwidth === undefined ? "inherit" : labelwidth.toString() + "px";
  let thisYear = new Date().getFullYear();
  let year = queryParams.year === undefined ? "ALL" : queryParams.year;
  return (
    <div title="Choose a specific year or all years" className="tableItem">
      <div className="tableItem" style={{ width: lw }}>
        Year:
      </div>
      <div className="tableItem">
        <select
          id="year"
          value={year}
          className="selectlist"
          size="1"
          onChange={onChange}
        >
          <option value="ALL">All Years</option>
          {Array.apply(null, { length: 10 }).map(function (obj, i) {
            let theYear = thisYear - parseInt(i);
            return (
              <option value={theYear.toString()} id={theYear.toString()}>
                {theYear}
              </option>
            );
          })}
        </select>
      </div>
    </div>
  );
};

let monthSelect = function (onChange, queryParams, labelwidth) {
  let lw = labelwidth === undefined ? "inherit" : labelwidth.toString() + "px";
  let month = queryParams.month === undefined ? "0" : queryParams.month;
  return (
    <div title="Choose a month or Year to Date" className="tableItem">
      <div className="tableItem" style={{ width: lw }}>
        Month:
      </div>
      <div className="tableItem">
        <select
          id="month"
          value={month}
          style={{ marginRight: "0px" }}
          className="selectlist"
          size="1"
          onChange={onChange}
        >
          <option value="0">Year to Date</option>
          <option value="01">January</option>
          <option value="02">February</option>
          <option value="03">March</option>
          <option value="04">April</option>
          <option value="05">May</option>
          <option value="06">June</option>
          <option value="07">July</option>
          <option value="08">August</option>
          <option value="09">September</option>
          <option value="10">October</option>
          <option value="11">November</option>
          <option value="12">December</option>
        </select>
      </div>
    </div>
  );
};

let eventSelect = function (onChange, queryParams, events, labelwidth) {
  let lw = labelwidth === undefined ? 0 : labelwidth;
  let event = queryParams.event === undefined ? "" : queryParams.event;
  let wkEvents = events === null ? [] : events;
  return (
    <div className="tableItem">
      <div className="tableItem" style={lw > 0 ? {} : { width: lw }}>
        Filter by Event:
      </div>
      <div className="tableItem">
        <select
          id="event"
          value={event}
          className="selectlist"
          size="1"
          onChange={onChange}
        >
          <option value="" selected="selected">
            All Events
          </option>
          {wkEvents.map(function (obj, i) {
            return <option value={obj}>{obj}</option>;
          })}
        </select>
      </div>
    </div>
  );
};

let stateSelect = function (onChange, queryParams, labelwidth) {
  let lw = labelwidth === undefined ? "inherit" : labelwidth.toString() + "px";
  let stateCode =
    queryParams.stateCode === undefined ? "" : queryParams.stateCode;

  return (
    <div title="Select a State" className="tableItem">
      <div className="tableItem" style={{ width: lw }}>
        Filter by State:
      </div>
      <div className="tableItem">
        <select
          id="stateCode"
          value={stateCode}
          className="selectlist"
          size="1"
          onChange={onChange}
        >
          <option value="ALL">All States</option>
          <option value="AL">Alabama</option>
          <option value="AK">Alaska</option>
          <option value="AZ">Arizona</option>
          <option value="AR">Arkansas</option>
          <option value="CA">California</option>
          <option value="CO">Colorado</option>
          <option value="CT">Connecticut</option>
          <option value="DE">Delaware</option>
          <option value="DC">District Of Columbia</option>
          <option value="FL">Florida</option>
          <option value="GA">Georgia</option>
          <option value="HI">Hawaii</option>
          <option value="ID">Idaho</option>
          <option value="IL">Illinois</option>
          <option value="IN">Indiana</option>
          <option value="IA">Iowa</option>
          <option value="KS">Kansas</option>
          <option value="KY">Kentucky</option>
          <option value="LA">Louisiana</option>
          <option value="ME">Maine</option>
          <option value="MD">Maryland</option>
          <option value="MA">Massachusetts</option>
          <option value="MI">Michigan</option>
          <option value="MN">Minnesota</option>
          <option value="MS">Mississippi</option>
          <option value="MO">Missouri</option>
          <option value="MT">Montana</option>
          <option value="NE">Nebraska</option>
          <option value="NV">Nevada</option>
          <option value="NH">New Hampshire</option>
          <option value="NJ">New Jersey</option>
          <option value="NM">New Mexico</option>
          <option value="NY">New York</option>
          <option value="NC">North Carolina</option>
          <option value="ND">North Dakota</option>
          <option value="OH">Ohio</option>
          <option value="OK">Oklahoma</option>
          <option value="OR">Oregon</option>
          <option value="PA">Pennsylvania</option>
          <option value="RI">Rhode Island</option>
          <option value="SC">South Carolina</option>
          <option value="SD">South Dakota</option>
          <option value="TN">Tennessee</option>
          <option value="TX">Texas</option>
          <option value="UT">Utah</option>
          <option value="VT">Vermont</option>
          <option value="VA">Virginia</option>
          <option value="WA">Washington</option>
          <option value="WV">West Virginia</option>
          <option value="WI">Wisconsin</option>
          <option value="WY">Wyoming</option>
        </select>
      </div>
    </div>
  );
};

export { orgSelect, yearSelect, monthSelect, eventSelect, stateSelect };
